const Description = () => {
  return (
    <div className="shoppingCartItem description">
      <p>Item:</p>
      <p className="descriptionPrice">Price:</p>
    </div>
  );
};

export default Description;
